import type {FC} from "react"
import {Link} from "react-router"
import type {LinkProps} from "react-router"

import {Button} from "./parkui-generated/button"
import type {ButtonProps} from "./parkui-generated/button"

export type Props = Omit<ButtonProps, "asChild"> & {
  to: LinkProps["to"]
  target?: LinkProps["target"]
}

export const ButtonLink: FC<Props> = ({to, children, ...props}) => (
  <Button asChild {...props}>
    <Link to={to}>{children}</Link>
  </Button>
)

ButtonLink.displayName = "ButtonLink"
